import React from 'react'
import styled from 'styled-components'
import HardwareSection from './HardwareSection'
import SoftwareSection from './SoftwareSection'

const ProductSection = () => {
    return (
        <div className="product__section">
            <Heading className="heading">
                <span>Our Products</span>
                <h4>Take a peek inside our Wonderworld</h4>
            </Heading>
            <HardwareSection />
            <SoftwareSection />
        </div>
    )
}

export default ProductSection

const Heading = styled.div`
        text-align: center;
        padding: 0rem 10rem;
        padding-bottom: 1rem;
        span{
        font-weight: 600;
        display: block;
        margin-bottom: 10px;
        color: #e21f36;
        }
        h4{
            color: #000219;
            font-size: 2rem;
            font-weight: 800;
        }
        p{
            color: #000219;
            font-size: 1.2rem;
        }
        @media screen and (max-width: 900px){
            padding: 0rem 1rem;
            /* h4{
                font-size: 1rem;
            } */
        }
`